"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.algorandWalletConnectorSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const walletConnectorInterfaces_1 = require("../walletConnectorInterfaces");
const initialAlgorandWalletConnectorState = Object.assign({}, walletConnectorInterfaces_1.defaultAlgorandWalletState);
exports.algorandWalletConnectorSlice = (0, toolkit_1.createSlice)({
    name: "walletConnector",
    initialState: initialAlgorandWalletConnectorState,
    reducers: {
        //error occured while connecting
        catchAlgorandWalletConnectError: (state, action) => {
            state = Object.assign(Object.assign({}, walletConnectorInterfaces_1.defaultAlgorandWalletState), { error: `${action.type}: ${action.payload.error}` });
        },
        algorandConnectWallet: (state) => {
            state.isAlgoConnected = false;
            state.isAlgoConnecting = true;
            state.error = "";
            state.algorandNetworkClient = undefined;
            state.isAlgosignerInitialized = false;
        },
        connectAlgorandWalletAddress: (state, action) => {
            state.connectedAlgorandWalletAddress = action.payload.address;
        },
        reconnectAlgorandWallet: (state) => {
            state.isAlgoConnected = false;
            state.isAlgoConnecting = true;
            state.error = "";
            state.algorandNetworkClient = undefined;
            state.isAlgosignerInitialized = false;
        },
        // getCustomerById
        algorandWalletConnected: (state, action) => {
            // console.log("action.payload.userAccount.currentWallet",action.payload.userAccount.currentWallet)
            state.isAlgoConnected = true;
            state.isAlgoConnecting = false;
            state.error = "";
            state.walletAddresses = action.payload.walletAddresses;
            state.isAlgosignerInitialized = true;
            state.algorandNetworkClient = action.payload.networkClient;
        },
        disconnectAlgorandWallet: (state, action) => {
            state.isAlgoConnected = false;
            state.isAlgoConnecting = false;
            state.connectedAlgorandWalletAddress = "";
            state.error = "";
            state.algorandNetworkClient = undefined;
            state.isAlgosignerInitialized = false;
        },
    },
});
//# sourceMappingURL=algorandWalletConnectorSlice.js.map